const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "301px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#10c9ac",
    d: "M 142.5,-0.5 C 148.5,-0.5 154.5,-0.5 160.5,-0.5C 197.956,5.33268 221.456,26.666 231,63.5C 232.388,77.455 232.888,91.455 232.5,105.5C 242.898,105.101 253.232,105.601 263.5,107C 269.52,109.683 273.353,114.183 275,120.5C 275.667,175.5 275.667,230.5 275,285.5C 273.427,293.235 268.927,298.235 261.5,300.5C 188.5,300.5 115.5,300.5 42.5,300.5C 35.9169,298.418 31.4169,294.085 29,287.5C 28.3333,231.167 28.3333,174.833 29,118.5C 30.7425,113.09 34.2425,109.256 39.5,107C 50.1023,105.597 60.769,105.097 71.5,105.5C 71.0889,91.1161 71.5889,76.7828 73,62.5C 82.7417,26.5876 105.908,5.58764 142.5,-0.5 Z M 143.5,27.5 C 173.083,25.8614 192.916,38.8614 203,66.5C 204.401,79.4479 204.901,92.4479 204.5,105.5C 169.5,105.5 134.5,105.5 99.5,105.5C 99.3335,93.8286 99.5001,82.1619 100,70.5C 105.76,47.2391 120.26,32.9057 143.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 139.5,140.5 C 174.791,137.128 199.125,151.628 212.5,184C 219.9,215.481 210.234,240.148 183.5,258C 148.436,273.795 119.603,266.295 97,235.5C 80.8379,202.326 87.0046,174.159 115.5,151C 123.041,146.217 131.041,142.717 139.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 52.5,143.5 C 56.8333,143.5 61.1667,143.5 65.5,143.5C 65.5,147.833 65.5,152.167 65.5,156.5C 61.1667,156.5 56.8333,156.5 52.5,156.5C 52.5,152.167 52.5,147.833 52.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 237.5,143.5 C 241.833,143.5 246.167,143.5 250.5,143.5C 250.5,147.833 250.5,152.167 250.5,156.5C 246.167,156.5 241.833,156.5 237.5,156.5C 237.5,152.167 237.5,147.833 237.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 52.5,170.5 C 56.8333,170.5 61.1667,170.5 65.5,170.5C 65.5,175.167 65.5,179.833 65.5,184.5C 61.1667,184.5 56.8333,184.5 52.5,184.5C 52.5,179.833 52.5,175.167 52.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 237.5,170.5 C 241.833,170.5 246.167,170.5 250.5,170.5C 250.5,175.167 250.5,179.833 250.5,184.5C 246.167,184.5 241.833,184.5 237.5,184.5C 237.5,179.833 237.5,175.167 237.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18caad",
    d: "M 181.5,179.5 C 189.339,180.18 191.839,184.18 189,191.5C 176.804,204.03 164.304,216.196 151.5,228C 148.697,228.755 146.03,228.422 143.5,227C 133.97,217.804 124.803,208.304 116,198.5C 114.963,191.87 117.797,188.703 124.5,189C 132.651,196.317 140.651,203.817 148.5,211.5C 159.547,200.785 170.547,190.118 181.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 52.5,198.5 C 56.8333,198.5 61.1667,198.5 65.5,198.5C 65.5,202.833 65.5,207.167 65.5,211.5C 65.5,207.167 65.5,202.833 65.5,198.5C 61.1667,198.5 56.8333,198.5 52.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 237.5,198.5 C 241.833,198.5 246.167,198.5 250.5,198.5C 250.5,202.833 250.5,207.167 250.5,211.5C 250.5,207.167 250.5,202.833 250.5,198.5C 246.167,198.5 241.833,198.5 237.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66dcc8",
    d: "M 52.5,198.5 C 52.5,202.833 52.5,207.167 52.5,211.5C 56.8333,211.5 61.1667,211.5 65.5,211.5C 61.03,212.486 56.3633,212.819 51.5,212.5C 51.1805,207.637 51.5139,202.97 52.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66dcc8",
    d: "M 237.5,198.5 C 237.5,202.833 237.5,207.167 237.5,211.5C 241.833,211.5 246.167,211.5 250.5,211.5C 246.03,212.486 241.363,212.819 236.5,212.5C 236.181,207.637 236.514,202.97 237.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 52.5,225.5 C 56.8333,225.5 61.1667,225.5 65.5,225.5C 65.5,230.167 65.5,234.833 65.5,239.5C 61.1667,239.5 56.8333,239.5 52.5,239.5C 52.5,234.833 52.5,230.167 52.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 237.5,225.5 C 241.833,225.5 246.167,225.5 250.5,225.5C 250.5,230.167 250.5,234.833 250.5,239.5C 246.167,239.5 241.833,239.5 237.5,239.5C 237.5,234.833 237.5,230.167 237.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 52.5,253.5 C 56.8333,253.5 61.1667,253.5 65.5,253.5C 65.5,257.833 65.5,262.167 65.5,266.5C 65.5,262.167 65.5,257.833 65.5,253.5C 61.1667,253.5 56.8333,253.5 52.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 237.5,253.5 C 241.833,253.5 246.167,253.5 250.5,253.5C 250.5,257.833 250.5,262.167 250.5,266.5C 250.5,262.167 250.5,257.833 250.5,253.5C 246.167,253.5 241.833,253.5 237.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66dcc8",
    d: "M 52.5,253.5 C 52.5,257.833 52.5,262.167 52.5,266.5C 56.8333,266.5 61.1667,266.5 65.5,266.5C 61.03,267.486 56.3633,267.819 51.5,267.5C 51.1805,262.637 51.5139,257.97 52.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66dcc8",
    d: "M 237.5,253.5 C 237.5,257.833 237.5,262.167 237.5,266.5C 241.833,266.5 246.167,266.5 250.5,266.5C 246.03,267.486 241.363,267.819 236.5,267.5C 236.181,262.637 236.514,257.97 237.5,253.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.7e3a23c990380af5b40780a62b3ab8f7.svg";
export { ForwardRef as ReactComponent };